import CATEGORIES from '../constants/categories';

function PillGroup({ options, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(opt => {
        const val = typeof opt === 'string' ? opt : opt.value;
        const label = typeof opt === 'string'
          ? opt.charAt(0).toUpperCase() + opt.slice(1)
          : opt.label;
        const active = value === val;
        return (
          <button
            key={val}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(val)}
            className={[
              'px-3 py-1 rounded-md text-xs font-medium transition-colors duration-150',
              active
                ? 'bg-terra-400 text-white'
                : 'bg-sand-100 text-ink-600 hover:bg-sand-200',
            ].join(' ')}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default function ItemFilterPanel({
  isOpen,
  onToggle,
  categoryFilter, setCategoryFilter,
  statusFilter, setStatusFilter, statusOptions,
  sortDir, setSortDir, sortOptions,
  activeFilterCount,
  clearFilters,
}) {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls="item-filter-panel"
          className="flex items-center gap-2 px-4 py-2 rounded-md border border-sand-200 bg-white text-sm font-medium text-ink-700 hover:bg-sand-50 transition-colors duration-150"
        >
          <svg className="w-4 h-4 text-ink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h18M7 8h10M11 12h2" />
          </svg>
          Filters
          {activeFilterCount > 0 && (
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-terra-400 text-white text-xs font-semibold">
              {activeFilterCount}
            </span>
          )}
        </button>
        {activeFilterCount > 0 && (
          <button
            type="button"
            onClick={clearFilters}
            className="text-sm text-terra-400 hover:text-terra-500 font-medium transition-colors duration-150"
          >
            Clear all
          </button>
        )}
      </div>

      {isOpen && (
        <div id="item-filter-panel" className="mt-3 p-4 bg-white border border-sand-200 rounded-lg flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Category</span>
            <select
              value={categoryFilter}
              onChange={e => setCategoryFilter(e.target.value)}
              className="w-full sm:w-56 px-3 py-2 border border-sand-200 rounded-md text-sm text-ink-900 bg-white focus:outline-none focus:ring-2 focus:ring-terra-400 focus:border-transparent transition"
            >
              <option value="all">All Categories</option>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Status</span>
            <PillGroup options={statusOptions} value={statusFilter} onChange={setStatusFilter} />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold text-ink-500 uppercase tracking-wide">Sort</span>
            <PillGroup options={sortOptions} value={sortDir} onChange={setSortDir} />
          </div>
        </div>
      )}
    </div>
  );
}
